import React, { useState, useEffect, useRef } from 'react';

const RUNS = [
  {
    title: 'destiny: nail salons · boston, ma · 500 leads',
    steps: [
      { label: 'INFO', tag: 'info', muted: false, html: 'Scraping Google Maps: <span class="sc-t-green">grid 5×5</span> · 25 cells' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Cell 12/25: 487 unique leads found' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Email found via Hunter: <span class="sc-t-green">owner@glamournails.com</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: '⬡ Generating site with Claude Haiku...', frames: [
        '⬡ Generating site with Claude Haiku',
        '⬡ Generating site with Claude Haiku.',
        '⬡ Generating site with Claude Haiku..',
        '⬡ Generating site with Claude Haiku...',
      ], frameDelay: 90 },
      { label: 'LOG',  tag: 'log',  muted: true,  html: '➴ Deploying to destiny.tavernix.io/glamour-nails' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Email sent: <span class="sc-t-green">destiny.tavernix.io/glamour-nails</span>' },
      { label: 'INFO', tag: 'info', muted: true,  html: '[219/487] Prestige Beauty Lounge' },
    ],
  },
  {
    title: 'destiny: pitch flow · med spas · miami, fl',
    steps: [
      { label: 'INFO', tag: 'info', muted: false, html: 'Opening pitch workflow: <span class="sc-t-green">Coastal Renew Med Spa</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Review summary generated: 4.8★ average across top leads' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: '▸ Streaming pitch draft from reviews + offer context...', frames: [
        '▸ Streaming pitch draft',
        '▸ Streaming pitch draft from reviews',
        '▸ Streaming pitch draft from reviews + offer context',
        '▸ Streaming pitch draft from reviews + offer context...',
      ], frameDelay: 95 },
      { label: 'DONE', tag: 'done', muted: false, html: 'Pitch angle locked: <span class="sc-t-green">fill low-booking weekday slots</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Subject line + CTA personalized for owner tone' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Campaign queued: <span class="sc-t-green">57 personalized emails</span>' },
      { label: 'INFO', tag: 'info', muted: true,  html: 'Next lead: Lumina Aesthetics' },
    ],
  },
  {
    title: 'destiny: lead report · dentists · austin, tx',
    steps: [
      { label: 'INFO', tag: 'info', muted: false, html: 'Compiling lead report: <span class="sc-t-green">Westlake Dental</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Pulling reviews, hours, site tech stack, and contact data' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: '➴ Rendering PDF sections...', frames: [
        '➴ Rendering executive summary',
        '➴ Rendering opportunities + review sentiment',
        '➴ Rendering contact sheet + screenshot appendix',
        '➴ Rendering PDF sections...',
      ], frameDelay: 100 },
      { label: 'DONE', tag: 'done', muted: false, html: 'Report exported: <span class="sc-t-green">westlake-dental-intel.pdf</span>' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Attachment added to outbound sequence' },
      { label: 'INFO', tag: 'info', muted: true,  html: 'Lead report ready for Riverbend Family Dentistry' },
    ],
  },
  {
    title: 'destiny: med spas · miami, fl · 620 leads',
    steps: [
      { label: 'INFO', tag: 'info', muted: false, html: 'Refreshing lead queue: <span class="sc-t-green">South Beach + Brickell</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Cell 18/36: 612 unique leads found' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Email found via Apollo: <span class="sc-t-green">hello@coastalrenew.com</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'LLM enrichment pass: highlighting low-review, high-photo leads' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: '⬡ Generating site with Claude Haiku...', frames: [
        '⬡ Generating hero copy + offers',
        '⬡ Generating social proof + review blocks',
        '⬡ Generating CTA + booking flow',
        '⬡ Generating site with Claude Haiku...',
      ], frameDelay: 90 },
      { label: 'DONE', tag: 'done', muted: false, html: 'Landing page deployed: <span class="sc-t-green">destiny.tavernix.io/coastal-renew</span>' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Outbound queued: <span class="sc-t-green">57 personalized emails</span>' },
      { label: 'INFO', tag: 'info', muted: true,  html: '[301/612] Lumina Aesthetics' },
    ],
  },
  {
    title: 'destiny: dentists · austin, tx · 440 leads',
    steps: [
      { label: 'INFO', tag: 'info', muted: false, html: 'Scanning Google Maps: <span class="sc-t-green">radius expanded</span> for coverage' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Cell 9/16: 438 unique leads found' },
      { label: 'DONE', tag: 'done', muted: false, html: 'Contact resolved via website crawl: <span class="sc-t-green">drpatel@westlakedental.com</span>' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Scoring opportunity: low-review leads prioritized' },
      { label: 'LOG',  tag: 'log',  muted: true,  html: 'Destiny fallback spin-up...', frames: [
        'Destiny fallback spin-up',
        'Destiny voice model warm',
        'Destiny fallback armed for missing inboxes',
        'Destiny fallback spin-up...',
      ], frameDelay: 95 },
      { label: 'DONE', tag: 'done', muted: false, html: 'SMS + voice follow-up ready for unverified contacts' },
      { label: 'INFO', tag: 'info', muted: true,  html: '[174/438] Riverbend Family Dentistry' },
    ],
  },
];

const ScouterTerminal = () => {
  const stateRef = useRef({
    title: RUNS[0].title,
    lines: [],
    liveStep: null,
    liveHtml: '',
  });
  const [, setTick] = useState(0);
  const mountedRef = useRef(true);
  const timerRef = useRef(null);

  useEffect(() => {
    mountedRef.current = true;

    const repaint = () => {
      if (mountedRef.current) setTick(n => n + 1);
    };

    const schedule = (ms, fn) => {
      timerRef.current = setTimeout(() => {
        if (mountedRef.current) fn();
      }, ms);
    };

    const playStep = (ri, vi) => {
      const run = RUNS[ri];

      if (vi >= run.steps.length) {
        schedule(1800, () => {
          const ni = (ri + 1) % RUNS.length;
          stateRef.current = { title: RUNS[ni].title, lines: [], liveStep: null, liveHtml: '' };
          repaint();
          schedule(420, () => playStep(ni, 0));
        });
        return;
      }

      const step = run.steps[vi];

      if (step.frames) {
        let fi = 0;
        stateRef.current = { ...stateRef.current, liveStep: step, liveHtml: step.frames[0] };
        repaint();

        const nextFrame = () => {
          if (fi < step.frames.length - 1) {
            fi++;
            stateRef.current = { ...stateRef.current, liveHtml: step.frames[fi] };
            repaint();
            schedule(step.frameDelay || 90, nextFrame);
            return;
          }
          stateRef.current = {
            ...stateRef.current,
            lines: [...stateRef.current.lines, step],
            liveStep: null,
            liveHtml: '',
          };
          repaint();
          schedule(step.holdDelay || 380, () => playStep(ri, vi + 1));
        };

        schedule(step.frameDelay || 90, nextFrame);
        return;
      }

      stateRef.current = { ...stateRef.current, liveStep: step, liveHtml: step.html };
      repaint();
      schedule(120, () => {
        stateRef.current = {
          ...stateRef.current,
          lines: [...stateRef.current.lines, step],
          liveStep: null,
          liveHtml: '',
        };
        repaint();
        schedule(step.holdDelay || 520, () => playStep(ri, vi + 1));
      });
    };

    schedule(320, () => playStep(0, 0));

    return () => {
      mountedRef.current = false;
      clearTimeout(timerRef.current);
    };
  }, []);

  const { title, lines, liveStep, liveHtml } = stateRef.current;

  return (
    <div className="sc-wrap">
      <div className="sc-terminal">
        <div className="sc-bar">
          <span className="sc-dot sc-dot-r" />
          <span className="sc-dot sc-dot-y" />
          <span className="sc-dot sc-dot-g" />
          <span className="sc-title">{title}</span>
        </div>
        <div className="sc-body">
          {lines.map((line, i) => (
            <div className="sc-line" key={i}>
              <span className={`sc-tag sc-tag-${line.tag}`}>{line.label}</span>
              <span
                className={line.muted ? 'sc-text sc-text-muted' : 'sc-text'}
                dangerouslySetInnerHTML={{ __html: line.html }}
              />
            </div>
          ))}
          {liveStep && (
            <div className="sc-line">
              <span className={`sc-tag sc-tag-${liveStep.tag}`}>{liveStep.label}</span>
              <span
                className="sc-text sc-text-live"
                dangerouslySetInnerHTML={{ __html: liveHtml }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScouterTerminal;
